import React, { useState, useEffect } from "react";
import { useForm, FormContext } from "react-hook-form";
import { Grid, Box, Paper } from "@material-ui/core";
import DateComponent from "../../../../components/DateComponent";
import useStyles from "../../../../themes/makeStyles";
import PathsandTitle from "../../../../constants/pathsAndTitle";
import MainHeading from "../../../../components/MainHeading";
import TextField from "../../../../components/TextField";
import Button from "@material-ui/core/Button";
import clsx from "clsx";
import FormValidationErrorMessage from "../../../../components/FormValidationErrorMessage";
import Autocomplete from "../../../../components/AutoComplete";
import Notifications from "../../../../components/Notifications";
import LabelConstantsData from "../../../../constants/LabelConstantsData";
import { default as Apiservices } from "../../../../common";
import PickListOptions from "../../../../constants/PickListOptions";
import CreateWagonSchedule from "./createwagonschedule";
import SkeletonComponent from "../../../../components/SkeletonComponent";
import DateTimePicker from "../../../../components/DateTimePicker";
import moment from "moment";

export default function CreateScheduleHeader(props) {
  const classes = useStyles();
  const [scheduleTypeOption, setScheduleTypeOption] = useState("");
  const [compositionTypeOption, setCompositionTypeOption] = useState("");
  const [rakeNameOptions, setRakeNameOptions] = useState([]);
  const [rakeMasterList, setRakeMasterList] = useState([]);
  const [rohPohMasterList, setRohPohMasterList] = useState([]);
  const [resetvalues, setResetvalues] = useState(true);
  const [isEdit, setIsEdit] = useState(props.location.isEdit);
  const [isDisable, setIsDisable] = useState(false);
  const [wagonMasterListMainData, setWagonMasterListMainData] = useState([]);
  const [scheduleType, setScheduleType] = useState("");
  const [depoNameOptions, setDepoNameOptions] = useState([]);
  const [selectedRakeType, setSelectedRakeType] = useState("");
  const [isRakeSelected, setIsRakeSelected] = useState(false);
  const [isRakeCompositionSelected, setIsRakeCompositionSelected] =
    useState(false);
  const [isScheduleTypeSelected, setIsScheduleTypeSelected] = useState(false);
  const [loading, setLoading] = useState(false);
  const [wagonData, setWagonData] = useState([]);
  const [departureDateTimeFromBaseDepot, setDepartureDateTimeFromBaseDepot] =
    useState("");
  const [arrivalAtBasePohDepot, setArrivalAtBasePohDepot] = useState("");
  const [scheduleStatusCompleted, setScheduleStatusCompleted] = useState(false);

  let defaultValues = {
    schedule_maintenance_id: "",
    rake_name: "",
    rake_composition: "",
    schedule_type: "",
    last_unloading_date: undefined,
    last_unloading_point: "",
    poh_depot: "",
    roh_depot: "",
    arrival_at_base_poh_depot: undefined,
    distance_from_last_unloading_to_base_poh_depot: "",
    rake_formation_date_at_base_poh_depot: undefined,
    departure_date_time_from_base_poh_depot: undefined,
    distance_from_poh_depot_to_loading_point: "",
    arrival_time_at_next_loading_point: undefined,
  };

  const methods = useForm({
    mode: "onChange",
    validateCriteriaMode: "all",
    submitFocusError: true,
    defaultValues,
  });

  const {
    control,
    errors,
    handleSubmit,
    setValue,
    reset,
    getValues,
    validateform,
    triggerValidation,
  } = methods;

  const [notify, setNotify] = useState({
    isOpen: false,
    message: "",
    type: "",
    timing: "",
  });

  const preparePostData = (submitteddata) => {
    let postdata = {};

    postdata.rake_name =
      submitteddata.rake_name && submitteddata.rake_name.label
        ? submitteddata.rake_name.label
        : submitteddata.rake_name;
    postdata.rake_type = selectedRakeType;
    postdata.rake_composition =
      submitteddata.rake_composition && submitteddata.rake_composition.label
        ? submitteddata.rake_composition.label
        : submitteddata.rake_composition;
    postdata.schedule_type =
      submitteddata.schedule_type && submitteddata.schedule_type.label
        ? submitteddata.schedule_type.label
        : submitteddata.schedule_type;
    postdata.last_unloading_date = submitteddata.last_unloading_date;
    postdata.last_unloading_point = submitteddata.last_unloading_point;
    postdata.poh_depot = submitteddata.poh_depot;
    postdata.roh_depot = submitteddata.roh_depot;
    postdata.arrival_at_base_poh_depot =
      submitteddata.arrival_at_base_poh_depot || "";
    postdata.distance_from_last_unloading_to_base_poh_depot =
      submitteddata.distance_from_last_unloading_to_base_poh_depot;
    postdata.rake_formation_date_at_base_poh_depot =
      submitteddata.rake_formation_date_at_base_poh_depot || "";
    postdata.departure_date_time_from_base_poh_depot =
      submitteddata.departure_date_time_from_base_poh_depot || "";
    postdata.distance_from_poh_depot_to_loading_point =
      submitteddata.distance_from_poh_depot_to_loading_point;
    postdata.arrival_time_at_next_loading_point =
      submitteddata.arrival_time_at_next_loading_point || null;
    postdata.created_or_updated_by = sessionStorage.getItem("user_email");
    postdata.schedule_status = "Active";
    postdata.bpc_no =
      submitteddata.bpc_no && submitteddata.bpc_no.label
        ? submitteddata.bpc_no.label
        : submitteddata.bpc_no;
    postdata.placement_date_time = submitteddata.placement_date_time || null;
    postdata.no_of_wagon_due = submitteddata.no_of_wagon_due
      ? Number(submitteddata.no_of_wagon_due)
      : null;
    if (submitteddata.schedule_maintenance_id)
      postdata.schedule_maintenance_id = submitteddata.schedule_maintenance_id;
    return postdata;
  };

  const setDepoMasterDropdownOptions = (depoMasterDataObj) => {
    let listDepoNames = [];
    depoMasterDataObj.records.map((odObj) => {
      let depoNamesObj = {};
      depoNamesObj.value = odObj.depo_name;
      depoNamesObj.label = odObj.depo_name;
      listDepoNames.push(depoNamesObj);
    });
    setDepoNameOptions(listDepoNames);
  };

  const [bpcList, setBPCList] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      const allMasterListDetails = await Promise.all([
        Apiservices.searchRakeMaster(),
        Apiservices.getDepoMasterList(),
        Apiservices.getRohPohScheduleMasterList(),
      ]);
      const rakeMasterListDetails = allMasterListDetails[0];
      const depoMasterListDetails = allMasterListDetails[1];
      const rohPohMasterListDetails = allMasterListDetails[2];

      setRakeMasterList(rakeMasterListDetails);
      setMasterDropdownOptions(rakeMasterListDetails);
      setDepoMasterDropdownOptions(depoMasterListDetails);
      setRohPohMasterList(rohPohMasterListDetails.records || []);
      setScheduleTypeOption(PickListOptions.TYPE_OF_MAINTENANCE_OPTIONS);
      setCompositionTypeOption(PickListOptions.RAKE_COMPOSITION_OPTIONS);

      setTimeout(async () => {
        if (props.location.schedule_maintenance_id) {
          let params = {};
          params.schedule_maintenance_id =
            props.location.schedule_maintenance_id;
          let listResponce =
            await Apiservices.getScheduleMaintenanceList(params);
          console.log("listResponce: ", listResponce);

          if (listResponce && listResponce.records.length > 0) {
            reset(listResponce.records[0]);
            const rake_name = listResponce.records[0]?.rake_name || "";
            const schedule_type = listResponce.records[0]?.schedule_type || "";

            const departure_date_time_from_base_poh_depot =
              listResponce.records[0]
                ?.departure_date_time_from_base_poh_depot || "";
            const arrival_at_base_poh_depot =
              listResponce.records[0]?.arrival_at_base_poh_depot || "";

            changeScheduleTypeHandle(schedule_type);

            if (listResponce.records[0]?.schedule_status === "Completed") {
              setScheduleStatusCompleted(true);
            }
            setIsDisable(true);
            setIsRakeSelected(true);
            setIsRakeCompositionSelected(true);

            const selectedRake = rakeMasterListDetails?.records?.find(
              (rake) => rake.rake_name === rake_name,
            );

            if (selectedRake) {
              setSelectedRakeType(selectedRake.rake_type);
            }

            setArrivalAtBasePohDepot(arrival_at_base_poh_depot);
            setDepartureDateTimeFromBaseDepot(
              departure_date_time_from_base_poh_depot,
            );

            if (listResponce.records[0].wagon_composition_details.length > 0) {
              setWagonMasterListMainData(
                listResponce.records[0].wagon_composition_details,
              );
            }

            setLoading(false);
          }
        }
      }, 100);
    };
    fetchData();
  }, []);

  const setMasterDropdownOptions = (masterDataObj) => {
    let listRakeNames = [];
    masterDataObj.records.map((odObj) => {
      let rakeNamesObj = {};
      rakeNamesObj.value = odObj.rake_name;
      rakeNamesObj.label = odObj.rake_name;
      listRakeNames.push(rakeNamesObj);
    });
    setRakeNameOptions(listRakeNames);
  };

  const lastCompositionDataFromChild = async (data) => {
    setWagonData(data);
  };

  const [ExpectedDateofDeparture, setExpectedDateofDeparture] =
    useState(undefined);

  const calculateExpectedDateofDeparture = async (key, data) => {
    let placementDate;
    let wagonDue;

    if (key === "Placement Date Time") {
      placementDate = data ? moment(data) : null;
      wagonDue = Number(methods.getValues("no_of_wagon_due"));
    } else {
      placementDate = methods.getValues("placement_date_time")
        ? moment(methods.getValues("placement_date_time"))
        : null;
      wagonDue = Number(data[0]?.target?.value);
      console.log(placementDate, wagonDue);
    }

    if (
      !placementDate ||
      !placementDate.isValid() ||
      !wagonDue ||
      wagonDue <= 0
    ) {
      return;
    }

    const X = scheduleType === "ROH" ? 15 : 25;
    const Y = selectedRakeType === "BFNS" ? 43 : 58;
    const daysToAdd = Math.ceil((X / Y) * wagonDue);

    let finalDate = placementDate.add(daysToAdd, "days").format("YYYY-MM-DD");
    console.log("finalDate", finalDate);

    setExpectedDateofDeparture(finalDate);
    setValue("expected_date_of_departure", finalDate);
  };

  const changeRakeNameHandle = async (rakeName) => {
    setLoading(true);
    let queryParams = { rake_name: rakeName, schedule_status: "Active" };
    const validateWagonMaintenanceByRakeName =
      await Apiservices.getScheduleMaintenanceList(queryParams);

    const getBPCNoList = await Apiservices.getBPCNo({
      filter: { rake_name: rakeName },
    });
    const bpcListResponce = getBPCNoList.Records.map((item) => {
      return {
        label: item.bpc_no,
        value: item.bpc_no,
      };
    });

    setBPCList(bpcListResponce);

    if (validateWagonMaintenanceByRakeName.records.length > 0) {
      setNotify({
        isOpen: true,
        message: `Maintenance is already in under progress`,
        type: "error",
        timing: 2000,
      });
      setIsRakeSelected(false);
      setLoading(false);
      return;
    }

    setIsRakeSelected(true);
    setLoading(false);
  };

  const changeRakeCompositionHandle = async (rakeComposition) => {
    setIsDisable(true);
    setLoading(true);

    const submitteddata = methods.getValues();
    const rakeName =
      submitteddata.rake_name && submitteddata.rake_name.label
        ? submitteddata.rake_name.label
        : submitteddata.rake_name;

    let queryParams = {};
    if (rakeComposition === "Running") {
      queryParams = { present_rake_name: rakeName };
    } else {
      queryParams = { mother_rake_name: rakeName };
    }

    const wagonMasterlistDetails =
      await Apiservices.wagonMasterListByRakeName(queryParams);

    queryParams = { rake_name: rakeName };
    const getLatestJobDetailsByRakeNameList =
      await Apiservices.getLatestJobDetailsByRakeNameList(queryParams);

    if (getLatestJobDetailsByRakeNameList.records.length > 0) {
      const latestJobDetailsByRakeName =
        getLatestJobDetailsByRakeNameList.records[0] &&
        getLatestJobDetailsByRakeNameList.records[0].length > 0
          ? getLatestJobDetailsByRakeNameList.records[0][0]
          : {};

      if (
        !latestJobDetailsByRakeName.loaded &&
        !latestJobDetailsByRakeName.movement
      ) {
        setNotify({
          isOpen: true,
          message: `No Loaded and Movement job found for rake: ${rakeName}`,
          type: "error",
          timing: 2000,
        });
        setLoading(false);
        return;
      }

      if (!latestJobDetailsByRakeName.loaded) {
        setNotify({
          isOpen: true,
          message: `No Loaded job found for rake: ${rakeName}`,
          type: "error",
          timing: 2000,
        });
        setLoading(false);
        return;
      }

      if (!latestJobDetailsByRakeName.movement) {
        setNotify({
          isOpen: true,
          message: `No Movement job found for rake: ${rakeName}`,
          type: "error",
          timing: 2000,
        });
        setLoading(false);
        return;
      }

      if (
        latestJobDetailsByRakeName.loaded &&
        latestJobDetailsByRakeName.loaded?.destination
      ) {
        setValue(
          "last_unloading_point",
          latestJobDetailsByRakeName.loaded.destination,
        );
      } else {
        setValue("last_unloading_point", "");
        setNotify({
          isOpen: true,
          message: `No Unloading Point found for job: ${latestJobDetailsByRakeName.loaded.job_id}`,
          type: "error",
          timing: 2000,
        });
        setLoading(false);
        return;
      }

      if (
        latestJobDetailsByRakeName.loaded &&
        (latestJobDetailsByRakeName.loaded?.unloading_end_date_time ||
          latestJobDetailsByRakeName.loaded?.unloading_completion_datetime)
      ) {
        let s =
          latestJobDetailsByRakeName.loaded?.unloading_end_date_time ||
          latestJobDetailsByRakeName.loaded?.unloading_completion_datetime;
        setValue("last_unloading_date", s);
      } else {
        setValue("last_unloading_date", undefined);
        setNotify({
          isOpen: true,
          message: `No Unloading Date found for job: ${latestJobDetailsByRakeName.loaded.job_id}`,
          type: "error",
          timing: 2000,
        });
        setLoading(false);
        return;
      }

      if (
        latestJobDetailsByRakeName.movement &&
        latestJobDetailsByRakeName.movement?.arrival_time_destination
      ) {
        setValue(
          "arrival_at_base_poh_depot",
          latestJobDetailsByRakeName.movement.arrival_time_destination,
        );
        setArrivalAtBasePohDepot(
          latestJobDetailsByRakeName.movement.arrival_time_destination.split(
            "T",
          )[0],
        );
        setValue(
          "placement_date_time",
          latestJobDetailsByRakeName.movement.placement_time_of_rake,
        );
      } else {
        setValue("arrival_at_base_poh_depot", undefined);
        setNotify({
          isOpen: true,
          message: `No Arrival Time found for job: ${latestJobDetailsByRakeName.movement.job_id}`,
          type: "error",
          timing: 2000,
        });
        setLoading(false);
        return;
      }
    }
    if (wagonMasterlistDetails.records.length === 0) {
      setNotify({
        isOpen: true,
        message: `No wagon found in the wagon master for rake: ${rakeName}`,
        type: "error",
        timing: 2000,
      });
      setLoading(false);
      return;
    }
    setTimeout(async () => {
      const selectedRake = rakeMasterList?.records?.find(
        (rake) => rake.rake_name === rakeName,
      );
      if (selectedRake) {
        setSelectedRakeType(selectedRake.rake_type);
        if (!selectedRake.name_of_base_depot) {
          setNotify({
            isOpen: true,
            message: `No Base Depot found for rake: ${rakeName}`,
            type: "error",
            timing: 2000,
          });
          setLoading(false);
          return;
        } else {
          setValue("roh_depot", selectedRake.name_of_base_depot);
        }
        if (!selectedRake.name_of_poh_depot) {
          setNotify({
            isOpen: true,
            message: `No POH Depot found for rake: ${rakeName}`,
            type: "error",
            timing: 2000,
          });
          setLoading(false);
          return;
        } else {
          setValue("poh_depot", selectedRake.name_of_poh_depot);
        }

        setWagonMasterListMainData(wagonMasterlistDetails.records);
        setLoading(false);
        setIsRakeCompositionSelected(true);
      }
    }, 100);
  };

  const changeScheduleTypeHandle = async (scheduleType) => {
    setLoading(true);
    setScheduleType(scheduleType);
    setIsScheduleTypeSelected(true);
    setLoading(false);
  };

  const updateDepartureDateTime = async (data) => {
    if (data) {
      setDepartureDateTimeFromBaseDepot(data.toISOString().split("T")[0]);
    } else {
      setDepartureDateTimeFromBaseDepot(undefined);
    }
  };

  const onSubmitForm = async () => {
    const submitteddata = methods.getValues();
    const postdata = preparePostData(submitteddata);
    let formValid = await methods.triggerValidation();
    for (let index = 0; index < wagonData.length; index++) {
      const element = wagonData[index];
      element["wagon_status"] = "Under Maintenance";
      element["expected_date_of_departure"] =
        submitteddata.expected_date_of_departure;
    }
    const payload = {
      ...postdata,
      ...{ wagon_data: wagonData },
    };
    // // console.log(payload);
    if (formValid) {
      // // console.log(postdata, wagonData);
      const saveScheduleMaintenanceResponse =
        await Apiservices.saveScheduleMaintenance(payload);
      if (saveScheduleMaintenanceResponse.issuccess) {
        if (isEdit) {
          setNotify({
            isOpen: true,
            message: `Schedule Maintenance ${LabelConstantsData.NOTIFICATION_INFO.EDIT_MESSAGE}`,
            type: "success",
            timing: 3000,
          });
        } else {
          if (saveScheduleMaintenanceResponse.Records.length > 0) {
            methods.setValue(
              "schedule_maintenance_id",
              saveScheduleMaintenanceResponse.Records[0].job_id,
            );
          }
          setNotify({
            isOpen: true,
            message: `Schedule Maintenance ${LabelConstantsData.NOTIFICATION_INFO.SUCESS_MESSAGE}`,
            type: "success",
            timing: 3000,
          });
        }
      } else {
        setNotify({
          isOpen: true,
          message: `${LabelConstantsData.NOTIFICATION_INFO.ERROR_MESSAGE}`,
          type: "error",
          timing: 2000,
        });
      }
    } else {
      setNotify({
        isOpen: true,
        message: `Please fill mandatory fields`,
        type: "error",
        timing: 2000,
      });
    }
  };

  const onFinalSubmitForm = async () => {
    const submitteddata = methods.getValues();
    const postdata = preparePostData(submitteddata);
    let formValid = await methods.triggerValidation();
    if (!postdata.departure_date_time_from_base_poh_depot) {
      formValid = false;
    }

    let rake_roh_poh_date = null;
    for (let index = 0; index < wagonData.length; index++) {
      const element = wagonData[index];
      element["wagon_status"] =
        element.move_with === "Rake" ? "Running" : element.move_with;
      element["wagon_sub_status"] = "Fit";
      element["wagon_roh_poh"] = element.actual_roh_poh_date;
      if (!rake_roh_poh_date && element.actual_roh_poh_date) {
        rake_roh_poh_date = element.actual_roh_poh_date;
      }
      element["expected_date_of_departure"] =
        submitteddata.expected_date_of_departure;
    }

    postdata.is_final_submit = true;
    postdata.rake_roh_poh_date = rake_roh_poh_date;
    postdata.schedule_status = "Completed";
    const payload = {
      ...postdata,
      ...{ wagon_data: wagonData },
    };
    // // console.log(payload);
    if (formValid) {
      // // console.log(postdata, wagonData);
      const saveScheduleMaintenanceResponse =
        await Apiservices.saveScheduleMaintenance(payload);
      if (saveScheduleMaintenanceResponse.issuccess) {
        if (isEdit) {
          setNotify({
            isOpen: true,
            message: `Schedule Maintenance ${LabelConstantsData.NOTIFICATION_INFO.EDIT_MESSAGE}`,
            type: "success",
            timing: 3000,
          });
        } else {
          if (saveScheduleMaintenanceResponse.Records.length > 0) {
            methods.setValue(
              "schedule_maintenance_id",
              saveScheduleMaintenanceResponse.Records[0].job_id,
            );
          }
          setNotify({
            isOpen: true,
            message: `Schedule Maintenance ${LabelConstantsData.NOTIFICATION_INFO.SUCESS_MESSAGE}`,
            type: "success",
            timing: 3000,
          });
        }
      } else {
        setNotify({
          isOpen: true,
          message: `${LabelConstantsData.NOTIFICATION_INFO.ERROR_MESSAGE}`,
          type: "error",
          timing: 2000,
        });
      }
    } else {
      setNotify({
        isOpen: true,
        message: `Please fill mandatory fields`,
        type: "error",
        timing: 2000,
      });
    }
  };

  return (
    <FormContext {...methods}>
      <React.Fragment>
        <MainHeading
          title={PathsandTitle.PathsHeading.ScheduleMaintenance}
          path={PathsandTitle.TitlesNavigation.ScheduleMaintenance}
        />
        <Box py={1}>
          <Paper elevation={0}>
            <Box p={3}>
              <form key={resetvalues} noValidate id="commodity-master">
                <Grid container spacing={2}>
                  <Grid
                    style={{ display: "none" }}
                    item
                    xs={12}
                    sm={4}
                    spacing={2}
                  >
                    <TextField
                      name="schedule_maintenance_id"
                      fullWidth
                      label="schedule_maintenance_id"
                      placeholder="schedule_maintenance_id"
                      control={control}
                      defaultValue={""}
                      disabled={false}
                    />
                  </Grid>
                  <Grid item xs={12} sm={4} spacing={2}>
                    <Autocomplete
                      name="rake_name"
                      control={control}
                      Values={rakeNameOptions}
                      required={true}
                      rules={{ required: true }}
                      disabled={isEdit || isDisable}
                      error={errors.rake_name}
                      getValueChanged={(data) => {
                        changeRakeNameHandle(data.value);
                      }}
                      label="Rake Name"
                    />
                    {errors.rake_name && (
                      <FormValidationErrorMessage
                        errors={errors}
                        errorMessagePrefix="Rake Name"
                        name="rake_name"
                      />
                    )}
                  </Grid>
                  {isRakeSelected && (
                    <>
                      <Grid item xs={12} sm={4} spacing={2}>
                        <Autocomplete
                          name="rake_composition"
                          control={control}
                          Values={compositionTypeOption}
                          required={true}
                          rules={{ required: true }}
                          disabled={isEdit || isRakeCompositionSelected}
                          error={errors.rake_composition}
                          getValueChanged={(data) => {
                            changeRakeCompositionHandle(data.value);
                          }}
                          label="Rake Composition"
                        />
                        {errors.rake_composition && (
                          <FormValidationErrorMessage
                            errors={errors}
                            errorMessagePrefix="Rake Composition"
                            name="rake_composition"
                          />
                        )}
                      </Grid>
                      <Grid item xs={12} sm={4} spacing={2}>
                        <Autocomplete
                          name="schedule_type"
                          control={control}
                          Values={scheduleTypeOption}
                          required={true}
                          rules={{ required: true }}
                          disabled={isEdit}
                          error={errors.schedule_type}
                          getValueChanged={(data) => {
                            changeScheduleTypeHandle(data.value);
                          }}
                          label="Types of Schedule Maintenance"
                        />
                        {errors.schedule_type && (
                          <FormValidationErrorMessage
                            errors={errors}
                            errorMessagePrefix="Types of Schedule Maintenance"
                            name="schedule_type"
                          />
                        )}
                      </Grid>
                      <Grid item xs={12} sm={4} spacing={2}>
                        <DateComponent
                          label="Last Unloading Date"
                          name="last_unloading_date"
                          fullWidth
                          rules={{ required: true }}
                          control={control}
                          required
                          disabled={true}
                          error={errors.last_unloading_date}
                        />
                        {errors.last_unloading_date && (
                          <FormValidationErrorMessage
                            errors={errors}
                            errorMessagePrefix="Last Unloading Date"
                            name="last_unloading_date"
                            dateValidationFailed={true}
                          />
                        )}
                      </Grid>
                      <Grid item xs={12} sm={4} spacing={2}>
                        <TextField
                          name="last_unloading_point"
                          fullWidth
                          rules={{ required: true }}
                          label="Last Unloading Point"
                          placeholder="Last Unloading Point"
                          control={control}
                          defaultValue={""}
                          disabled={true}
                          error={errors.last_unloading_point}
                          required
                        />
                        {errors.last_unloading_point && (
                          <FormValidationErrorMessage
                            errors={errors}
                            errorMessagePrefix="Last Unloading Point"
                            name="last_unloading_point"
                          />
                        )}
                      </Grid>
                      <Grid item xs={12} sm={4} spacing={2}>
                        <Autocomplete
                          name={`poh_depot`}
                          control={control}
                          Values={depoNameOptions}
                          defaultValue={""}
                          error={errors.poh_depot}
                          label="POH Depot"
                          disabled={true}
                          rules={{ required: true }}
                          required
                        />
                        {errors.poh_depot && (
                          <FormValidationErrorMessage
                            errors={errors}
                            errorMessagePrefix="POH Depot"
                            name="poh_depot"
                          />
                        )}
                      </Grid>
                      <Grid item xs={12} sm={4} spacing={2}>
                        <Autocomplete
                          name={`roh_depot`}
                          control={control}
                          Values={depoNameOptions}
                          defaultValue={""}
                          error={errors.roh_depot}
                          label="ROH Depot"
                          disabled={true}
                          rules={{ required: true }}
                          required
                        />
                        {errors.roh_depot && (
                          <FormValidationErrorMessage
                            errors={errors}
                            errorMessagePrefix="ROH Depot"
                            name="roh_depot"
                          />
                        )}
                      </Grid>
                      <Grid item xs={12} sm={4} spacing={2}>
                        <DateTimePicker
                          Label="Arrival at Base/POH Depot"
                          name="arrival_at_base_poh_depot"
                          id="arrival_at_base_poh_depot"
                          required
                          rules={{ required: true }}
                          control={control}
                          disabled={true}
                          error={errors.arrival_at_base_poh_depot}
                        />
                        {errors.arrival_at_base_poh_depot && (
                          <FormValidationErrorMessage
                            errors={errors}
                            errorMessagePrefix="Arrival at Base/POH Depot"
                            name="arrival_at_base_poh_depot"
                            dateValidationFailed={true}
                          />
                        )}
                      </Grid>
                      <Grid item xs={12} sm={4} spacing={2}>
                        <TextField
                          name="distance_from_last_unloading_to_base_poh_depot"
                          type={"number"}
                          multiline={false}
                          fullWidth
                          rules={{ required: false }}
                          label="Distance From Last Unloading to Base/POH Depot"
                          placeholder="Distance From Last Unloading to Base/POH Depot"
                          control={control}
                          defaultValue={""}
                          disabled={false}
                          error={
                            errors.distance_from_last_unloading_to_base_poh_depot
                          }
                        />
                        {errors.distance_from_last_unloading_to_base_poh_depot && (
                          <FormValidationErrorMessage
                            errors={errors}
                            errorMessagePrefix="Distance From Last Unloading to Base/POH Depot"
                            name="distance_from_last_unloading_to_base_poh_depot"
                          />
                        )}
                      </Grid>
                      <Grid item xs={12} sm={4} spacing={2}>
                        <DateComponent
                          label="Rake Formation Date At Base/POH Depot"
                          name={`rake_formation_date_at_base_poh_depot`}
                          id="rake_formation_date_at_base_poh_depot"
                          control={control}
                          // required
                          rules={{ required: false }}
                          disabled={false}
                          error={errors.rake_formation_date_at_base_poh_depot}
                        />
                        {errors.rake_formation_date_at_base_poh_depot && (
                          <FormValidationErrorMessage
                            errors={errors}
                            errorMessagePrefix="Rake Formation Date At Base/POH Depot"
                            name="rake_formation_date_at_base_poh_depot"
                          />
                        )}
                      </Grid>
                      <Grid item xs={12} sm={4} spacing={2}>
                        <DateTimePicker
                          Label="Departure Date Time From Base/POH Depot"
                          name={`departure_date_time_from_base_poh_depot`}
                          id="departure_date_time_from_base_poh_depot"
                          control={control}
                          rules={{ required: false }}
                          error={errors.departure_date_time_from_base_poh_depot}
                          getValueChanged={(data) => {
                            updateDepartureDateTime(data);
                          }}
                        />
                        {errors.departure_date_time_from_base_poh_depot && (
                          <FormValidationErrorMessage
                            errors={errors}
                            errorMessagePrefix="Departure Date Time From Base/POH Depot"
                            name="departure_date_time_from_base_poh_depot"
                            dateValidationFailed={true}
                          />
                        )}
                      </Grid>
                      <Grid item xs={12} sm={4} spacing={2}>
                        <TextField
                          name="distance_from_poh_depot_to_loading_point"
                          type={"number"}
                          multiline={false}
                          fullWidth
                          rules={{ required: false }}
                          label="Distance From POH Depot to Loading Point"
                          placeholder="Distance From POH Depot to Loading Point"
                          control={control}
                          defaultValue={""}
                          disabled={false}
                          error={
                            errors.distance_from_poh_depot_to_loading_point
                          }
                        />
                        {errors.distance_from_poh_depot_to_loading_point && (
                          <FormValidationErrorMessage
                            errors={errors}
                            errorMessagePrefix="Distance From POH Depot to Loading Point"
                            name="distance_from_poh_depot_to_loading_point"
                          />
                        )}
                      </Grid>
                      <Grid item xs={12} sm={4} spacing={2}>
                        <DateTimePicker
                          Label="Arrival Time At Next Loading Point"
                          name={`arrival_time_at_next_loading_point`}
                          id="arrival_time_at_next_loading_point"
                          control={control}
                          rules={{ required: false }}
                          disabled={false}
                          error={errors.arrival_time_at_next_loading_point}
                        />

                        {errors.arrival_time_at_next_loading_point && (
                          <FormValidationErrorMessage
                            errors={errors}
                            errorMessagePrefix="Arrival Time At Next Loading Point"
                            name="arrival_time_at_next_loading_point"
                            dateValidationFailed={true}
                          />
                        )}
                      </Grid>
                      <Grid item xs={12} sm={4}>
                        <Autocomplete
                          name="bpc_no"
                          control={control}
                          Values={bpcList}
                          error={errors.bpc_no}
                          label="BPC No"
                          rules={{ required: false }}
                        />
                        {errors.bpc_no && (
                          <FormValidationErrorMessage
                            errors={errors}
                            errorMessagePrefix="BPC No"
                            name="bpc_no"
                          />
                        )}
                      </Grid>
                      <Grid item xs={12} sm={4} spacing={2}>
                        <DateTimePicker
                          Label="Placement Date Time"
                          name={`placement_date_time`}
                          id="placement_date_time"
                          control={control}
                          rules={{ required: false }}
                          disabled={false}
                          error={errors.placement_date_time}
                          getValueChanged={(data) =>
                            calculateExpectedDateofDeparture(
                              "Placement Date Time",
                              data,
                            )
                          }
                        />
                        {errors.placement_date_time && (
                          <FormValidationErrorMessage
                            errors={errors}
                            errorMessagePrefix="Placement Date Time"
                            name="placement_date_time"
                          />
                        )}
                      </Grid>
                      <Grid item xs={12} sm={4} spacing={2}>
                        <TextField
                          name="no_of_wagon_due"
                          type={"number"}
                          multiline={false}
                          fullWidth
                          rules={{ required: false }}
                          label="No. of wagons Due"
                          placeholder="No. of wagons Due"
                          control={control}
                          defaultValue={""}
                          disabled={false}
                          error={errors.no_of_wagon_due}
                          onBlur={(e) =>
                            calculateExpectedDateofDeparture(
                              "No. of wagons Due",
                              e,
                            )
                          }
                        />
                        {errors.no_of_wagon_due && (
                          <FormValidationErrorMessage
                            errors={errors}
                            errorMessagePrefix="No. of wagons Due"
                            name="no_of_wagon_due"
                          />
                        )}
                      </Grid>
                      <Grid item xs={12} sm={4} spacing={2}>
                        <DateComponent
                          label="Expected Date of Formation"
                          name={`expected_date_of_departure`}
                          id="expected_date_of_departure"
                          control={control}
                          rules={{ required: false }}
                          disabled={false}
                          error={errors.expected_date_of_departure}
                        />
                        {errors.expected_date_of_departure && (
                          <FormValidationErrorMessage
                            errors={errors}
                            errorMessagePrefix="Expected Date of Departure"
                            name="expected_date_of_departure"
                          />
                        )}
                      </Grid>
                    </>
                  )}
                </Grid>
              </form>
              {loading && isRakeSelected ? (
                <SkeletonComponent />
              ) : (
                <>
                  <Grid>
                    {wagonMasterListMainData.length > 0 &&
                      isRakeCompositionSelected &&
                      isScheduleTypeSelected && (
                        <CreateWagonSchedule
                          {...props}
                          wagonMasterListMainDataList={wagonMasterListMainData}
                          scheduleType={scheduleType}
                          selectedRakeType={selectedRakeType}
                          rohPohMasterList={rohPohMasterList}
                          actualDateOfDeparture={departureDateTimeFromBaseDepot}
                          arrivalAtBasePohDepot={arrivalAtBasePohDepot}
                          onSubmitLastComposition={lastCompositionDataFromChild}
                          expectedDateofDeparture={ExpectedDateofDeparture}
                          setNotify={setNotify}
                        />
                      )}
                  </Grid>
                  <Box pt={1}>
                    {wagonMasterListMainData.length > 0 &&
                      isRakeCompositionSelected &&
                      isScheduleTypeSelected && (
                        <Grid container spacing={2} justify="flex-end">
                          <Grid item>
                            <Button
                              variant="contained"
                              color="primary"
                              className={clsx(classes.subTextButton)}
                              type="button"
                              onClick={onSubmitForm}
                              disabled={scheduleStatusCompleted}
                            >
                              {!isEdit ? "Save" : "Update"}
                            </Button>
                          </Grid>
                          <Grid item>
                            <Button
                              variant="contained"
                              color="primary"
                              className={clsx(classes.subTextButton)}
                              type="button"
                              onClick={onFinalSubmitForm}
                              disabled={scheduleStatusCompleted}
                            >
                              {"Final Submit"}
                            </Button>
                          </Grid>
                        </Grid>
                      )}
                  </Box>
                </>
              )}
              <Notifications notify={notify} setNotify={setNotify} />
            </Box>
          </Paper>
        </Box>
      </React.Fragment>
    </FormContext>
  );
}
